import { Vector2 } from "@app/shared";
import cn from "classnames";
import { useState } from "react";
import { EnumSelect } from "../../shared";
import { ConfigurationViewer } from "./ConfigurationViewer/ConfigurationViewer";
import { FusionViewer } from "./FusionViewer/FusionViewer";
import { LayoutViewer } from "./LayoutViewer/LayoutViewer";
import { ProjectWithData } from "./ProjectWithData";
import { RadarViewer } from "./RadarViewer/RadarViewer";
import { ResultsViewer } from "./ResultsViewer/ResultsViewer";
import { UserResultsViewer } from "./ResultsViewer/UserResultsViewer";
import { VideoViewer } from "./VideoViewer/VideoViewer";

export enum DataViewType {
    Radar,
    Video,
    Layout,
    Sim_Results,
    User_Results,
    Fusion,
    Configuration
};

export type DataViewerProps = {
    project: ProjectWithData;
    currentTimeS: number;
    isScrubbing: boolean;
    isPlaying: boolean;
    onFrameChange: (timeInS: number) => void;
    setNeedsVideoClick?: (needsClick: boolean) => void;
    needsVideoClick?: boolean;
    setLastVideoClick?: (videoPosition: Vector2) => void;
    lastVideoClick?: Vector2;
    initialView: DataViewType | undefined;
    closeProject?: () => void;
    setProject: React.Dispatch<React.SetStateAction<Partial<ProjectWithData>>>;
};

//Data viewer can be Radar, Video, Layout, Output Results.  It should take in a project & a position in time that it can scrub to
//
//Video will have ability to turn on/off layers (radar points, annotations, layout, etc)
//Radar will be the chart that neil created for plotting over time
//Layout will show targets on 2d layout of facility in facility coordinates
//Results will be a table that lists events and targets.  Need a way to indicate where we are in this scrollable list of events.  This pane also allows for re-simulation
//
//Configuration will allow for users to change the settings of this project
export const DataViewer: React.FC<DataViewerProps> = (props) => {
    const [view, setView] = useState(props.initialView);


    return (
        <div className={cn({ "flex-grow": view !== DataViewType.Video }, "flex flex-col border border-separators-page p-0 m-1")}>
            <div className="w-full bg-background-top-nav-tabs text-right p-1">
                <EnumSelect className="w-100" enumType={DataViewType} value={view} onChange={(val) => setView(val)} />
            </div>
            {view === DataViewType.Video &&
                <VideoViewer {...props} />
            }
            {view === DataViewType.Radar &&
                <RadarViewer {...props} />
            }
            {view === DataViewType.Layout &&
                <LayoutViewer {...props} />
            }
            {view === DataViewType.Sim_Results &&
                <ResultsViewer {...props} />
            }
            {view === DataViewType.Configuration &&
                <ConfigurationViewer {...props} />
            }
            {view === DataViewType.Fusion &&
                <FusionViewer {...props} />
            }
            {view === DataViewType.User_Results &&
                <UserResultsViewer {...props} />
            }
        </div>
    );
}